//import Vue from 'vue'
//import router from '../router';

export default {
    state: {
        steps: 3,
        step: undefined
    },
    getters: {
        step: state => state.step,
        steps: state => state.steps
    },
    actions: {
        
    },
    mutations: {
        
    }
};